import * as THREE from 'three'
import { Water } from 'three/examples/jsm/objects/Water.js';
import {isDev} from '../../config'
export default {
    name: 'ground',
    label: '地面',
    create: function (_, { scene }) {
        const geometry = new THREE.PlaneGeometry(1000, 1000);
        const material = new THREE.MeshBasicMaterial( {color: 0x888888, side: THREE.DoubleSide ,name:'shuini'})
        material.map=new THREE.TextureLoader().load(isDev+'/channels/shuini.jpg',t=>{
          t.wrapS = THREE.RepeatWrapping
          t.wrapT = THREE.RepeatWrapping
          t.repeat.set( 10, 10 )
        })
        const mesh=new THREE.Mesh(geometry,material)
        mesh.rotation.x=90*Math.PI/180
        console.info('mesh',mesh)
        return mesh
    }
}
